/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {NgModule} from '@angular/core';
import {ProfessionalReferenceService} from './professional-reference.service';

@NgModule({
    providers: [
        ProfessionalReferenceService
    ]
})
export class ProfessionalReferenceModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/reference/professional-reference.module.ts